import { ApolloQueryResult } from '@apollo/client';
import ApolloClient from 'core/apollo-client';
import * as DepositReportQuery from 'core/gql/queries/financials-deposits';
import OutstandingQuery from 'core/gql/queries/financials-outstanding';
import * as TransactionReportQuery from 'core/gql/queries/financials-transaction';
import * as ShowOrganization from 'core/gql/queries/show-organizations';

export async function getOrganizationByOrgId<T>(
  orgId: number
): Promise<ApolloQueryResult<T>> {
  try {
    return await ApolloClient.query({
      query: ShowOrganization.QUERY,
      variables: { organizationId: orgId },
    });
  } catch (e) {
    throw new Error(`Error in getOrganizationByOrgId: ${e}`);
  }
}

export async function getDeposits<T>(
  orgId: number,
  dateColumn: string,
  startDate: Date,
  endDate: Date
): Promise<ApolloQueryResult<T>> {
  try {
    return await ApolloClient.query({
      query: DepositReportQuery.QUERY,
      variables: {
        organizationId: orgId,
        dateColumn,
        startDate,
        endDate,
      },
      fetchPolicy: 'cache-first',
    });
  } catch (e) {
    throw new Error(`Error in getDeposits: ${e}`);
  }
}

export async function getOutstandingReport<T>(
  orgId: number,
  startDate: Date,
  endDate: Date
): Promise<ApolloQueryResult<T>> {
  try {
    return await ApolloClient.query({
      query: OutstandingQuery,
      variables: {
        organizationId: orgId,
        startDate,
        endDate,
      },
      fetchPolicy: 'cache-first',
    });
  } catch (e) {
    throw new Error(`Error in getOutstandingReport: ${e}`);
  }
}

export async function getTransactions<T>(
  orgId: number,
  dateColumn: string,
  startDate: Date,
  endDate: Date
): Promise<ApolloQueryResult<T>> {
  try {
    return await ApolloClient.query({
      query: TransactionReportQuery.QUERY,
      variables: {
        organizationId: orgId,
        dateColumn,
        startDate,
        endDate,
      },
      fetchPolicy: 'cache-first',
    });
  } catch (e) {
    throw new Error(`Error in getTransactions: ${e}`);
  }
}
